// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating PatientHistory model structure.
 * @see #/components/schemas/PatientHistory - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface PatientHistory {
    /**
     * The date when history was created.
     * @dataFormat date-time
     */
    date: string;
    /**
     * The text part of the history.
     *
     */
    value: string;
    /**
     * The history type.  * `physician-report` - PHYSICIAN_REPORT * `senior-physician-order` - SENIOR_PHYSICIAN_ORDER * `event` - EVENT * `speech-therapy-report` - SPEECH_THERAPY_REPORT * `physical-therapy-report` - PHYSICAL_THERAPY_REPORT * `neurology-report` - NEUROLOGY_REPORT * `care-report` - CARE_REPORT
     *
     */
    type: PatientHistory.TypeEnum;
    /**
     * The identifier of the related Patient.
     * @dataFormat uuid
     */
    patient_id: string;
    /**
     * The identifier of the related Encounter.
     * @dataFormat uuid
     */
    encounter_id: string;
    /**
     * Practitioner unique id.
     * @dataFormat uuid
     */
    last_changed_by: string | null;
    /**
     * Unique id.
     * @dataFormat uuid
     */
    id: string;
    /**
     * The practitioner that authored the history entry.
     * @dataFormat uuid
     */
    author_id: string;
    /**
     * The event code for patient history of type event  * `encounter_started` - ENCOUNTER_STARTED * `encounter_ended` - ENCOUNTER_ENDED * `ventilation_started` - VENTILATION_STARTED * `ventilation_stopped` - VENTILATION_STOPPED * `body_examination` - BODY_EXAMINATION
     *
     */
    event_code?: PatientHistory.EventCodeEnum;
    /**
     * The custom payload for the history of type event
     *
     */
    payload?: { [key: string]: any };
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PatientHistory
 */
export namespace PatientHistory {
    export type TypeEnum =
        | 'physician-report'
        | 'senior-physician-order'
        | 'event'
        | 'speech-therapy-report'
        | 'physical-therapy-report'
        | 'neurology-report'
        | 'care-report';
    export const TypeEnum = {
        PhysicianReport: 'physician-report' as TypeEnum,
        SeniorPhysicianOrder: 'senior-physician-order' as TypeEnum,
        Event: 'event' as TypeEnum,
        SpeechTherapyReport: 'speech-therapy-report' as TypeEnum,
        PhysicalTherapyReport: 'physical-therapy-report' as TypeEnum,
        NeurologyReport: 'neurology-report' as TypeEnum,
        CareReport: 'care-report' as TypeEnum,
    };
    export type EventCodeEnum =
        | 'encounter_started'
        | 'encounter_ended'
        | 'ventilation_started'
        | 'ventilation_stopped'
        | 'body_examination';
    export const EventCodeEnum = {
        EncounterStarted: 'encounter_started' as EventCodeEnum,
        EncounterEnded: 'encounter_ended' as EventCodeEnum,
        VentilationStarted: 'ventilation_started' as EventCodeEnum,
        VentilationStopped: 'ventilation_stopped' as EventCodeEnum,
        BodyExamination: 'body_examination' as EventCodeEnum,
    };

    /**
     * PatientHistory Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The date when history was created.
         * @dataFormat date-time
         */
        @TransformDate() date: Date;
        /**
         * The text part of the history.
         * @type string (`dataFormat` is missing)
         */
        value: string;
        /**
         * The history type.  * `physician-report` - PHYSICIAN_REPORT * `senior-physician-order` - SENIOR_PHYSICIAN_ORDER * `event` - EVENT * `speech-therapy-report` - SPEECH_THERAPY_REPORT * `physical-therapy-report` - PHYSICAL_THERAPY_REPORT * `neurology-report` - NEUROLOGY_REPORT * `care-report` - CARE_REPORT
         * @type string (`dataFormat` is missing)
         */
        type: PatientHistory.TypeEnum;
        /**
         * The identifier of the related Patient.
         * @dataFormat uuid
         */
        patientId: string;
        /**
         * The identifier of the related Encounter.
         * @dataFormat uuid
         */
        encounterId: string;
        /**
         * Practitioner unique id.
         * @dataFormat uuid
         */
        lastChangedBy: string | null;
        /**
         * Unique id.
         * @dataFormat uuid
         */
        id: string;
        /**
         * The practitioner that authored the history entry.
         * @dataFormat uuid
         */
        authorId: string;
        /**
         * The event code for patient history of type event  * `encounter_started` - ENCOUNTER_STARTED * `encounter_ended` - ENCOUNTER_ENDED * `ventilation_started` - VENTILATION_STARTED * `ventilation_stopped` - VENTILATION_STOPPED * `body_examination` - BODY_EXAMINATION
         * @type string (`dataFormat` is missing)
         */
        eventCode?: PatientHistory.EventCodeEnum;
        /**
         * The custom payload for the history of type event
         * @type { [key: string]: any; } (`dataFormat` is missing)
         */
        payload?: { [key: string]: any };

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PatientHistory DTO
     * Transforms PatientHistory model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PatientHistory model */
        static toModel(obj: PatientHistory): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PatientHistory model */
        static toApi(obj: Model): PatientHistory {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PatientHistory;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
